import { EventStatusTypes, IOverviewEvents } from "interfaces";
import { Tag } from "components/tag";
import { abbreviateNumbers, currencySymbol, formatNumber } from "utills/helpers";

interface EventCardsProps {
  data?: IOverviewEvents[];
  pageSize: number;
  currentPage: number;
  _toggleActive?: (id: string, isActive: boolean) => void;
}

export const EventCards = ({data = [], _toggleActive, currentPage, pageSize }: EventCardsProps) => {

  const getEventStatusText = (statusType: EventStatusTypes) => {
    switch (statusType) {
      case EventStatusTypes.CLOSED: return "Closed";
      case EventStatusTypes.COMING: return "Coming soon";
      case EventStatusTypes.SELLING: return "On Selling";
      default: return "";
    }
  }
  
  return (
    <ul className="bg-white">
      {data.map((item: IOverviewEvents, index: number) => (
        <div key={index} className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl">
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              No
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {(currentPage - 1) * pageSize + 1 + index}
            </p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Status
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              <Tag text={getEventStatusText(item.selling_type)} type={item.selling_type}  />
            </p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Event name
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.event_name}
            </p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Gross Revenue
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.subtotal)}
            >
              {currencySymbol()} {abbreviateNumbers(item.subtotal)}
            </p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Orders
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.transactions)}
            >
              {abbreviateNumbers(item.transactions)}
            </p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Items
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.total_items)}
            >
              {abbreviateNumbers(item.total_items)}
            </p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Net Revenue
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.grand_total)}
            >
              {currencySymbol()} {abbreviateNumbers(item.grand_total)}
            </p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Discount
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.discount_coupon)}
            >
              {currencySymbol()} {abbreviateNumbers(item.discount_coupon)}
            </p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Promotion
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.discount_promotion)}
            >
              {currencySymbol()} {abbreviateNumbers(item.discount_promotion)}
            </p>
          </li>
        </div>
      ))}
    </ul>
  )
}